const AddressConstants = {
  ADDRESS_AUTO_COMPLETE: 'ADDRESS_AUTO_COMPLETE',
  ADDRESS_STATUS_FAILURE: 'FAILURE',
  UNIT_NUMBER_LENGTH_LIMIT: 20,
} as const;

export default AddressConstants;
